import React, { useReducer } from 'react'
import { GlobalContext } from './context'
import { initialState, reducers } from './context/reducers'
import Route from './route'

function App() {
  const [state, dispatch] = useReducer(reducers, initialState)

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      <Route />
    </GlobalContext.Provider>
  )
}

export default App
